export function isAdminRoute(slug: string): boolean {
    return slug.startsWith('/admin/');
}
